import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';
import { isAPICatchError } from '@/utils/utils';

@Component({
    name: 'class-details',
    components: {},
})

export default class RosterClassDetails extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private classList: any = [];

    private isLoading: boolean = false;

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;


    public created() {

        this.isLoading = true;
        this.fetchClasslist();
    }


    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    private onSelectPage(item: number) {
            this.isLoading = true;
            this.currentPage = item;
            this.offset = (item - 1) * this.pageLimit;
            this.fetchClasslist();

    }

    // ---------------------------------------------------------------------
    // Methods
    private fetchClasslist() {
        const params = {
            zipId: this.rosterData.id,
            offset: this.offset,
            limit: this.limit,
            is_required_sync: this.rosterData.showError,
        };

        rosterAPI.getRosterClass(params).then((classList) => {
            this.isLoading = false;
            if (!isAPICatchError(classList)) {
                this.classList = classList.classes;
                this.totalLength = classList.totalClassesCount;
            }
        });
    }
}
